import { cn } from "@/lib/tailwind";

interface Props {
  size: "large" | "medium" | "small" | "extra-small";
  placeholderText: string;
  primaryTextColor: string;
  secodaryTextColor: string;
  usePrimaryTextColor?: boolean;
  color?: string;
}

export const AvatarPlaceholder = ({ usePrimaryTextColor = true, ...props }: Props) => {
  // if(!props.usePrimaryTextColor) props.usePrimaryTextColor = false;

  const textColor = usePrimaryTextColor ? props.primaryTextColor : props.secodaryTextColor;

  let widthClass: string = "w-24";
  let textClass: string = "bg";

  switch (props.size) {
    case "large":
      widthClass = "w-24";
      textClass = "text-3xl";
      break;
    case "medium":
      widthClass = "w-16";
      textClass = "text-xl";
      break;
    case "small":
      widthClass = "w-10";
      textClass = "";
      break;
    case "extra-small":
      widthClass = "w-8";
      textClass = "text-base";
      break;
  }

  return (
    <div className="avatar placeholder">
      <div
        className={cn(
          "flex h-8 items-center justify-center rounded-full border-2 bg-transparent",
          `border-${textColor}`,
          widthClass,
        )}
      >
        {textClass !== "" && (
          <span className={cn(textClass, props.color ? props.color : "")}>
            {props.placeholderText}
          </span>
        )}
        {textClass === "" && (
          <span className={cn(textClass, props.color ? props.color : "")}>
            {props.placeholderText}
          </span>
        )}
      </div>
    </div>
  );
};
